import * as yup from 'yup';

const IllegalUnicodeRegexp = /[^\p{L}\p{M}\p{N}\p{Zs}\-().·'.]/u;
const DiacriticRegexp = /\p{M}/gu;
const PhoneNumberRegexp = /^\+?\d+$/;

const notOnlyDiacritics = (value = '') => {
	if (!value) return true;
	const withoutDiacritics = value.normalize('NFD').replace(DiacriticRegexp, '');
	return withoutDiacritics.trim().length > 0;
};

/** Per-message validation keys; pass overrides to a validator to customize wording per form. */
type TNameMessages = Record<
	'required' | 'min' | 'max' | 'illegalCharacters' | 'onlyDiacritics',
	string
>;
type TPhoneMessages = Record<'required' | 'max' | 'checkFormat', string>;

const firstNameMessages: TNameMessages = {
	required: 'firstName.required',
	min: 'firstName.min',
	max: 'firstName.max',
	illegalCharacters: 'firstName.illegalCharacters',
	onlyDiacritics: 'firstName.onlyDiacritics',
};

const lastNameMessages: TNameMessages = {
	required: 'surname.required',
	min: 'surname.min',
	max: 'surname.max',
	illegalCharacters: 'surname.illegalCharacters',
	onlyDiacritics: 'surname.onlyDiacritics',
};

const phoneMessages: TPhoneMessages = {
	required: 'phoneNumber.required',
	max: 'phoneNumber.max',
	checkFormat: 'phoneNumber.checkFormat',
};

export const firstNameValidator = (overrides: Partial<TNameMessages> = {}) => {
	const msg = { ...firstNameMessages, ...overrides };

	return yup
		.string()
		.trim()
		.required(msg.required)
		.min(2, msg.min)
		.max(50, msg.max)
		.test(
			'no-illegal-chars',
			msg.illegalCharacters,
			(value = '') => !IllegalUnicodeRegexp.test(value)
		)
		.test('not-only-diacritics', msg.onlyDiacritics, notOnlyDiacritics);
};

export const lastNameValidator = (overrides: Partial<TNameMessages> = {}) => {
	const msg = { ...lastNameMessages, ...overrides };

	return yup
		.string()
		.trim()
		.required(msg.required)
		.min(2, msg.min)
		.max(50, msg.max)
		.test(
			'no-illegal-chars',
			msg.illegalCharacters,
			(value = '') => !IllegalUnicodeRegexp.test(value)
		)
		.test('not-only-diacritics', msg.onlyDiacritics, notOnlyDiacritics);
};

export const phoneValidator = (overrides: Partial<TPhoneMessages> = {}) => {
	const msg = { ...phoneMessages, ...overrides };

	return yup
		.string()
		.trim()
		.required(msg.required)
		.max(20, msg.max)
		.test('is-number', msg.checkFormat, (v = '') => PhoneNumberRegexp.test(v));
};
